import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
}

.dashboard-page {
  color: #111827;
}

.generator-card {
  border-color: rgba(15, 23, 42, 0.08);
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.045), 0 24px 56px rgba(15, 23, 42, 0.075);
}

.generator-strategy-label,
.generator-round-label {
  color: #8e8e93;
  font-size: 0.6875rem;
  font-weight: 750;
  letter-spacing: -0.012em;
}

.generator-strategy-label {
  color: #3d7860;
}

.generator-round-label {
  font-variant-numeric: tabular-nums;
}

.generator-loading,
.generator-empty {
  min-height: 15rem;
}

.generator-loading-ball,
.generator-empty-ball {
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  background: #e9e9e6;
}

.generator-empty {
  color: #8e8e93;
}

.generator-empty-ball {
  border: 1px dashed #c8c8c4;
  background: #fafaf9;
}

.generated-list {
  overflow: hidden;
  border: 1px solid #e7e7e4;
  border-radius: 1rem;
  background: #f8f8f6;
}

.generated-row {
  display: flex;
  min-height: 3.4rem;
  align-items: center;
  justify-content: center;
  animation: generated-row-enter 0.24s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  transition: background-color 0.16s ease, border-color 0.16s ease;
}

.generated-row:hover {
  background: #fff;
}

.generated-row + .generated-row {
  border-top: 1px solid #e7e7e4;
}

.generated-numbers {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

@keyframes generated-row-enter {
  from {
    opacity: 0;
    transform: translateY(0.35rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.lotto-ball,
.lotto-ball-small {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 3px 8px rgba(15, 23, 42, 0.12);
  font-weight: 900;
}

.lotto-ball {
  width: 2rem;
  height: 2rem;
  font-size: 0.7rem;
}

.lotto-ball-small {
  width: 1.6rem;
  height: 1.6rem;
  font-size: 0.625rem;
}

.generate-button {
  background: #18181b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 5px 14px rgba(15, 23, 42, 0.14);
  transition: transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}

.generate-button:hover:not(:disabled) {
  background: #27272a;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12), 0 8px 20px rgba(15, 23, 42, 0.18);
  transform: translateY(-1px);
}

.generate-button:active:not(:disabled) {
  transform: scale(0.995);
}

.generate-button:disabled {
  opacity: 0.5;
}

.generation-note {
  color: #237a55;
}

.latest-draw-card {
  border-color: rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.04), 0 14px 34px rgba(15, 23, 42, 0.05);
}

.latest-draw-card:hover {
  border-color: rgba(15, 23, 42, 0.15);
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.075);
  transform: translateY(-1px);
}

@media (min-width: 640px) {
  .generated-row {
    min-height: 3.65rem;
  }
  .generated-numbers {
    justify-content: center;
    gap: 0.625rem;
  }
  .lotto-ball {
    width: 2.35rem;
    height: 2.35rem;
    font-size: 0.78rem;
  }
  .lotto-ball-small {
    width: 1.9rem;
    height: 1.9rem;
    font-size: 0.65rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .generated-row {
    animation: none;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public loading: boolean = true;
    public generating: boolean = false;
    public currentBatch: any = null;
    public latestDraw: any = null;
    public targetDrawNo: number = 0;
    public generationPolicy: any = { allowed: true };
    public syncStatus: any = null;
    public strategy: any = null;
    public generationNote: string = '';
    public loadError: string = '';
    private activeRequestKey: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        try {
            this.activeRequestKey = sessionStorage.getItem(
                'newlife.generation.request_key'
            ) || '';
        } catch (error) {
            this.activeRequestKey = '';
        }
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('overview');
            if (code !== 200) {
                this.loadError = data.message || '홈 화면을 불러오지 못했습니다.';
                return;
            }
            this.latestDraw = data.latest_draw;
            this.targetDrawNo = data.target_draw_no || 0;
            this.currentBatch = data.current_batch;
            this.generationPolicy = data.generation_policy || { allowed: true };
            this.syncStatus = data.sync_status || null;
            this.strategy = data.strategy || null;
        } catch (error) {
            this.loadError = '연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private rememberRequestKey(requestKey: string) {
        this.activeRequestKey = requestKey;
        try {
            sessionStorage.setItem('newlife.generation.request_key', requestKey);
        } catch (error) { }
    }

    private clearRequestKey() {
        this.activeRequestKey = '';
        try {
            sessionStorage.removeItem('newlife.generation.request_key');
        } catch (error) { }
    }

    private createRequestKey() {
        const cryptoApi = (window as any).crypto;
        if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
            return cryptoApi.randomUUID();
        }
        return [
            Date.now().toString(36),
            Math.random().toString(36).slice(2),
            Math.random().toString(36).slice(2)
        ].join('-').slice(0, 64);
    }

    public async generate() {
        if (this.generating) return;
        if (this.generationPolicy && this.generationPolicy.allowed === false) {
            await this.service.modal.error(
                this.generationPolicy.message || '현재 새 번호를 생성할 수 없습니다.'
            );
            return;
        }

        if (!this.activeRequestKey) {
            this.rememberRequestKey(this.createRequestKey());
        }
        this.generating = true;
        this.generationNote = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('generate_numbers', {
                request_key: this.activeRequestKey
            });
            if (data.policy) {
                this.generationPolicy = data.policy;
            }
            if (code === 200 || code === 201) {
                this.currentBatch = data.result;
                this.generationNote = data.result?.replayed
                    ? '방금 만든 번호를 다시 불러왔어요.'
                    : '';
                this.clearRequestKey();
                return;
            }

            if (code < 500) {
                this.clearRequestKey();
            }
            await this.service.modal.error(
                data.message || '번호 생성에 실패했습니다.'
            );
        } catch (error) {
            await this.service.modal.error(
                '생성 결과를 확인하지 못했어요. 다시 눌러도 번호가 중복 생성되지 않습니다.'
            );
        } finally {
            this.generating = false;
            await this.service.render();
        }
    }

    public numberClass(number: number) {
        if (number <= 10) return 'bg-amber-400 text-slate-950';
        if (number <= 20) return 'bg-blue-500 text-white';
        if (number <= 30) return 'bg-red-500 text-white';
        if (number <= 40) return 'bg-slate-500 text-white';
        return 'bg-emerald-500 text-white';
    }

    public shortDate(value: any) {
        return String(value || '').slice(0, 10);
    }

    public displaySets() {
        if (!this.currentBatch) return [];
        if (this.currentBatch.set_details?.length) {
            return this.currentBatch.set_details;
        }
        return (this.currentBatch.sets || []).map((numbers: number[]) => ({
            numbers
        }));
    }
}

export default PageDashboardComponent;